import styled from 'styled-components'

export const Root = styled('div')`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: auto;
  margin: auto;
  min-height: 100%;
  padding: 32px;
  width: 100%;

  ${props => props.theme.breakpoints.up('md')} {
    padding: 32px 64px;
  }
`

export const Header = styled('header')`
  width: 100%;
`

export const Body = styled('main')`
  box-sizing: border-box;
  flex: 1;
  width: 100%;
`

export const Footer = styled('footer')`
  width: 100%;
`

export const TopContent = styled('section')`
  width: 100%;
`
